const SET_CODING_PAGE_LOADED = 'SET_CODING_PAGE_LOADED';
const SET_SNAPSHOT_RECEIVED = 'SET_SNAPSHOT_RECEIVED';
const RESET_ACC_RECORDING_REDUCER = 'RESET_ACC_RECORDING_REDUCER';
const initialState = {};

const accRecordingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CODING_PAGE_LOADED:

      if (action.payload.is_coding_page_ready === true) return { ...state, is_coding_page_ready: true };

      return { ...state, is_coding_page_ready: false };

    case SET_SNAPSHOT_RECEIVED:

      if (action.payload.initial_snapshot_received === true) return { ...state, initial_snapshot_received: true };

      return { ...state, initial_snapshot_received: false };

    case RESET_ACC_RECORDING_REDUCER:

      return {};

    default:
      return state;
  }
};

export {
  SET_CODING_PAGE_LOADED,
  SET_SNAPSHOT_RECEIVED,
  RESET_ACC_RECORDING_REDUCER,
  accRecordingReducer
};
